import axios from 'axios';

export interface FaqType {
  id: string;
  question: string;
  answer: string;
  sort: number;
}

// よくある質問の取得
export const getFaq = async (): Promise<FaqType[]> => {
  const url = `https://${process.env.REACT_APP_MICRO_CMS_DOMAIN}.microcms.io/api/v1/${process.env.REACT_APP_MICRO_CMS_FAQ_ENDPOINT}`;
  const response = await axios.get(url, {
    headers: {
      'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY,
      'x-xsrf-token': undefined
    },
    params: {
      orders: 'sort'
    }
  });
  return response.data.contents;
};
